import styled from 'styled-components';

export const Container = styled.div`
padding-top: 7px;
  background: #44d68e;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border-width: 1px;
  border-style: solid;
  border-color: #167b00;
  display: table-cell;
  vertical-align: middle;
  vertical-align: center;
  text-align: center;
`;
